export const formatRequestCount = (count: number): string | number => {
  return count === -1 ? "∞" : count;
};
